<template>
  <section>
    <div class="col-md-12 col-sm-1">
      <multi-select v-model="setdata" tag-placeholder="ตำบล/แขวง" :custom-label="nameWithLang"
                    placeholder="ตำบล/แขวง" label="name" track-by="district_name"  :options="data"
                    @input="update" style="font-size: 12px"
      ></multi-select>
    </div>
  </section>
</template>

<script>
import axios from "axios";

export default {
  name: "district",
  data(){
    return{
      data:[],
      setdata:[],
    }
  },
  props: {
    remove: {
      type: Array,
      default: () => []
    },
    editDistrict: {
    // type: String | Number | Boolean | Object | {Number, String, Object},
      type: String,
      default: ''
      // type: String
    },
  },
  watch: {
    remove: function() {
      this.setdata = []
    },
    editDistrict:function () {
      let data = {
        'district_name' : this.editDistrict
      }
      axios.post('api/sysdata/findDistrict',data)
          .then(response => {
            this.setdata = response.data
          });
    }
  },
  computed:{

  },
  mounted(){
    this.getResults()
  },
  methods:{
    async getResults(){
      await axios.get('api/sysdata/getDistrict')
          .then(response => {
            this.data =response.data
            // this.setdata = response.data[185]
            // this.$emit("SetData", this.setdata.district_name);
          });
    },

    nameWithLang({district_name}){
      return `${district_name}`
    },

    update(data){
      if (data != null) {
        this.$emit("SetData", data.district_name);
      }
    },

  }
}
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
